import feedbackApi from '@/api/services/feedback'

const state = {
  campaignParams: {},
  feedbackCampaign: {},
  feedbackResponse: {},
  feedbackCompleted: false,
  feedbackError: {}
}

const getters = {
  getCampaignParams: (state) => {
    return state.campaignParams
  }
}

const actions = {
  getFeedbackCampaign ({ commit }, params) {
    commit('setCampaignParams', params)

    feedbackApi.getFeedbackCampaign(params).then(response => {
      commit('setCampaign', response.data)
    }).catch(error => {
      commit('setFeedbackError', error)
    })
  },

  submitFeedback ({ commit }, params) {
    let serviceParams = {
      serviceURL: state.feedbackCampaign.responseURL.url,
      serviceParams: params
    }

    feedbackApi.submit(serviceParams).then(response => {
      if (response.success) {
        commit('setFeedbackStatus', response.success)
        if (response.link) {
          setTimeout(function() {
            window.location = response.link
          }, 5000)
        }
      }
    })
  },

  getFeedbackResponse ({ commit }, params) {
    feedbackApi.getFeedbackResponse(params).then(response => {
      commit('setResponse', response.data)
    })
  }
}

const mutations = {
  setCampaignParams (state, params) {
    state.campaignParams = params
  },
  setCampaign (state, campaign) {
    state.feedbackCampaign = campaign
  },
  setResponse (state, response) {
    state.feedbackResponse = response
  },
  setFeedbackStatus  (state, status) {
    state.feedbackCompleted = status
  },
  setFeedbackError (state, error) {
    state.feedbackError = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
